module.exports = __webpack_public_path__ + "img/Icon=Nodejs.d8d6141d.svg";